module.exports = __webpack_public_path__ + "media/src/images/icons/flags/canada-a4e11c968460f63e2f58d49588555de6.svg";